import React from 'react';

export default function DissolutionNotice() {
  return (
    <div className='b-notice'>
      <div className='container'>
        <div className='b-notice__wrapper'>
          <p className='b-notice__title'>Disolución de las Cortes Generales</p>
          <p className='b-notice__text'>
            <strong>Aviso.</strong> Con la disolución de las Cortes Generales el 5 de octubre, las normas que no completaron su recorrido decaen. Puedes seguir consultando todas las iniciativas en Parlamentia.
          </p>
        </div>
      </div>
    </div>
  );
}